/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./whitelist.vue?vue&type=template&id=1a57dc12&scoped=true&"
import script from "./whitelist.vue?vue&type=script&lang=js&"
export * from "./whitelist.vue?vue&type=script&lang=js&"
import style0 from "./whitelist.vue?vue&type=style&index=0&id=1a57dc12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a57dc12",
  null
  
)

export default component.exports